module.exports = __webpack_public_path__ + "img/vehicle-solutions-logo-type1.d850f99c.png";